import React, { useState } from "react";
import MobileTable from "./components/MobileTable";
import DesktopTable from "./components/DesktopTable";

const RemoteTable = ({
  data,
  columns,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  title,
  showPagination = true,
  rowHeight = "30px",
  keyField = "num",
  className,
  noTitle = false,
  overflowScroll = false,
  hideBorderTop,
  sizePerPageList = [
    {
      text: "5",
      value: 5,
    },
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    /* {
      text: "همه",
      value: totalSize,
    }, */
  ],
  ...props
}) => {
  const [size, setSize] = useState(window.innerWidth);
  window.addEventListener('resize', () => { setSize(window.innerWidth); })
  return (
    <div className="system-table-manager">
      {
        size <= 768 &&
        <MobileTable
          data={data && data.length !== 0 ? data : []}
          columns={columns}
          props={props}
          noTitle={noTitle}
          title={title}
          currentPage={page}
          sizePerPage={sizePerPage}
          totalSize={totalSize}
          onTableChange={onTableChange}
          showPagination={showPagination}
          loading={props.loading}
        />
      }
      {
        size > 768 &&
        <DesktopTable 
          data={data && data.length !== 0 ? data : []}
          columns={columns}
          page={page}
          sizePerPage={sizePerPage}
          onTableChange={onTableChange}
          totalSize={totalSize}
          title={title}
          showPagination={ showPagination }
          rowHeight={rowHeight}
          keyField={keyField}
          className={className}
          noTitle={noTitle}
          overflowScroll={overflowScroll}
          hideBorderTop={hideBorderTop}
          sizePerPageList={sizePerPageList}
          props={props}
        />
      }
    </div>
  );
};

export default RemoteTable;
